import type { Router } from "@/typeDefinitions/custom/Router";
import { SQDCEventActionTypeInternalType, SQDCEventActionTypePreset } from "@/graphql";

const IHEquipments = () => import("./views/Equipments/IHEquipments.vue");
const CreateIHEquipment = () => import("./views/Equipments/CreateIHEquipment.vue");
const UpdateIHEquipment = () => import("./views/Equipments/UpdateIHEquipment.vue");

const IHMaintenanceSchedule = () => import("./views/IHMaintenanceSchedule.vue");
const IHWeakPointAnalysis = () => import("./views/IHWeakPointAnalysis.vue");
const IHConfigs = () => import("./views/IHConfigs.vue");
const CreateIHConfig = () => import("./views/CreateIHConfig.vue");
const UpdateIHConfig = () => import("./views/UpdateIHConfig.vue");

const router: Router.LicensedRouterExportType = [
  {
    path: "/ih/equipments",
    name: "IHEquipments",
    component: IHEquipments,
    meta: {
      rights: ["ih.admin"],
    },
  },
  {
    path: "/ih/equipment",
    name: "CreateIHEquipment",
    component: CreateIHEquipment,
    meta: {
      rights: ["ih.admin"],
    },
  },
  {
    path: "/ih/equipment/:id",
    name: "UpdateIHEquipment",
    component: UpdateIHEquipment,
    meta: {
      rights: ["ih.admin"],
      authorizationSiteResource: "ihEquipment",
    },
    props: (route) => ({
      id: Number(route.params.id),
    }),
  },
  {
    path: "/ih/maintenanceSchedule",
    name: "IHMaintenanceSchedule",
    component: IHMaintenanceSchedule,
    meta: {
      rights: ["ih.admin"],
    },
  },
  {
    path: "/ih/weakPointAnalysis",
    name: "IHWeakPointAnalysis",
    component: IHWeakPointAnalysis,
    meta: {
      rights: ["ih.admin"],
    },
  },
  {
    path: "/ih/IHConfigs",
    name: "IHConfigs",
    component: IHConfigs,
    meta: {
      rights: ["ih.admin"],
    },
  },
  {
    path: "/ih/configOverview",
    name: "IHConfigOverview",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
    meta: {
      rights: ["ih.admin"],
    },
    props: {
      internalType: SQDCEventActionTypeInternalType.IH,
      presets: [
        SQDCEventActionTypePreset.IHOrder,
        SQDCEventActionTypePreset.IHFailureNotice,
        SQDCEventActionTypePreset.IHMaintenance,
      ],
      titleKey: "router.IHConfigOverview",
    },
  },
  {
    path: "/ih/ihConfig/new/:siteId",
    name: "CreateIHConfig",
    component: CreateIHConfig,
    meta: {
      rights: ["ih.admin"],
    },
    props: (route) => {
      return {
        siteId: Number(route.params.siteId),
      };
    },
  },
  {
    path: "/ih/ihConfig/:id",
    name: "UpdateIHConfig",
    component: UpdateIHConfig,
    props: (route) => ({
      id: route.params?.id ? Number(route.params.id) : undefined,
    }),
    meta: {
      rights: ["ih.admin"],
      authorizationSiteResource: "ihConfig",
    },
  },
];

export default router;
